/**
 * list categories
 */


 // activate all cats button when no other button is active
 var component_list_categories = function() {

  var list = document.querySelector('.cat-list');

  if (typeof(list) != 'undefined' && list != null) {

    if (document.querySelectorAll('.cat-list .current-cat').length == 0) {
      var item_all = document.querySelector('.cat-item-all');
      item_all.classList.add('cat-item-active');
    }
  }

  // make the call chainable
  return this;

};
